/*
 * The app moved from hash routing (/#/demo) to path routing (/demo), but the
 * marketing site and old emails still link to the hash form. With path routing
 * those load "/" — the auth-only dashboard — and bounce visitors to /login.
 * Rewrite them to the real path before the router starts, keeping both the
 * page's own query (where Google Ads puts ?gclid=) and any query in the hash.
 */
export function legacyHashTarget({ search, hash }) {
  if (!hash || !hash.startsWith("#/") || hash === "#/") return null;
  const [path, hashQuery = ""] = hash.slice(1).split("?");
  const params = new URLSearchParams(search);
  new URLSearchParams(hashQuery).forEach((value, key) =>
    params.append(key, value),
  );
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

export function redirectLegacyHash() {
  try {
    const target = legacyHashTarget(window.location);
    if (target) window.history.replaceState(window.history.state, "", target);
  } catch {
    // Never block the app from booting.
  }
}
